export class SubscriptionCreationResult {
    static success(): SubscriptionCreationResult {
        return new SubscriptionCreationResult(true, undefined);
    }

    static failure(error: any): SubscriptionCreationResult {
        return new SubscriptionCreationResult(false, error);
    }

    private constructor(
        public success: boolean,
        public error: any
    ) { }
}
